'use client'

import React, { useEffect, useState } from 'react'
import { ConfigProvider } from 'antd'
import zhCN from 'antd/locale/zh_CN'
import enUS from 'antd/locale/en_US'
import { getLocaleOnClient } from '@/i18n'
import { useContext } from 'react'
import I18n from '@/context/i18n'

interface AntdLocaleProviderProps {
  children: React.ReactNode
}

const AntdLocaleProvider: React.FC<AntdLocaleProviderProps> = ({ children }) => {
  const [antdLocale, setAntdLocale] = useState(zhCN)
  
  // 监听语言变化
  useEffect(() => {
    const updateLocale = () => {
      const currentLocale = getLocaleOnClient()
      
      // 根据当前语言设置Ant Design的locale
      if (currentLocale === 'zh-Hans' || currentLocale === 'zh-CN') {
        setAntdLocale(zhCN)
      } else {
        setAntdLocale(enUS)
      }
    }

    // 初始设置
    updateLocale()

    // 监听storage变化（当语言切换时）
    const handleStorageChange = () => {
      updateLocale()
    }

    window.addEventListener('storage', handleStorageChange)
    
    // 监听自定义事件（当语言切换时）
    window.addEventListener('languageChange', updateLocale)

    return () => {
      window.removeEventListener('storage', handleStorageChange)
      window.removeEventListener('languageChange', updateLocale)
    }
  }, [])

  return (
    <ConfigProvider
      locale={antdLocale}
      theme={{
        token: {
          colorPrimary: '#327DFF',
          borderRadius: 2,
        },
      }}
    >
      {children}
    </ConfigProvider>
  )
}

export default AntdLocaleProvider 